import { Grid, makeStyles } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { MetaData } from "../../partials/Meta";
import { Page } from "../../partials/Page";
import { RegisterStep } from "../../PurchaseFlow";

const useStyles = makeStyles((theme) => ({
  box: {
    "& .MuiTypography-root": {
      textAlign: "center",
    },
  },
}));

const SignupPage: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const { t, ready } = useTranslation("signUp");
  const { title, description, ogTitle, ogImage }: MetaData =
    history.location?.state || {};

  const getMetaData = () => {
    return {
      title: title || t("signUpText"),
      ogTitle: ogTitle || "Kvix",
      description: description || t("metaDescription"),
      ogImage,
    } as MetaData;
  };

  if (!ready) {
    return null;
  }

  return (
    <Page meta={getMetaData()}>
      <Grid container alignItems="center" justify="center">
        <Grid item md={3} className={classes.box}>
          <RegisterStep />
        </Grid>
      </Grid>
    </Page>
  );
};

export default SignupPage;
